@if (employmentForm(); as employmentFormGroup) {
  <pr-acc-employment-form
    [form]="employmentFormGroup"
    [disabled]="disabled()"
    [canResumeNormalWork]="
      workCapacityForm().controls.canResumeNormalWork.valueChanges | async
    "
  />

  @if (employmentFormGroup.isEmployedOrSelfEmployed) {
    @if (workCapacityForm(); as workCapacityFormGroup) {
      <pr-acc-work-capacity-form
        [form]="workCapacityFormGroup"
        [disabled]="disabled()"
      />
    }
  }
}
